export const SET_TRADE_LOADING = 'SET_TRADE_LOADING'
export const SET_TRADE = 'SET_TRADE'
export const ADD_TRADE = 'ADD_TRADE'
export const EDIT_TRADE = 'EDIT_TRADE'
export const DELETE_TRADE = 'DELETE_TRADE'